/**
 * The four nutrients beyond calories and the big three.
 *
 * All eight are recorded for every food the app knows, and all four of these
 * are now shown. They used to be a preference, on the theory that four meters
 * is a wall of bars nobody reads — but that was only true stacked full-width.
 * On one line they are four small numbers, read as a set: is anything red
 * today. A setting for that is a setting nobody should have had to find.
 */

import type { NutrientKey } from '@gramas/shared'

export const SECONDARY_KEYS = ['fiber', 'sugars', 'satFat', 'salt'] as const

export type SecondaryKey = (typeof SECONDARY_KEYS)[number]

export const SECONDARY_LABEL: Readonly<Record<SecondaryKey, string>> = {
  fiber: 'Skaidulos',
  sugars: 'Cukrus',
  satFat: 'Sočiosios r.r.',
  salt: 'Druska',
}

export function isSecondaryKey(key: NutrientKey | string): key is SecondaryKey {
  return (SECONDARY_KEYS as readonly string[]).includes(key)
}
